<template>
  <div>
    购买记录
  </div>
</template>

<script>
export default {
  name: 'buy'
}
</script>

<style scoped>

</style>
